import React, { Component }   from 'react'
import {connect}              from 'react-redux';
import {Redirect}               from 'react-router';
import AlunosListGruposturmas from '../../../container/renderListAvatarAlunos';
import { GetGruposAlunos }    from '../../../actions/grupoAction';
import FlashCarregando        from '../../../container/FlashCarregando';


class Equipe_Aluno_Lista extends Component {

    constructor(props){
        super(props);
        this.state = { equ_nome : "Carrengando...",load:false,listaAlunos:[], redirect         : false, }
    }
    componentWillMount(){
      this.props.GetGruposAlunos(this.props.equ_id).then((response)=>{

        if (response.payload.data) {
          this.setState({load:true,listaAlunos:response.payload.data});
        }else{
          this.setState({listaAlunos:[]});
        } 
       
       
      });    
      if(this.props.equipe){this.setState({equ_nome:this.props.equipe.equ_nome});}
    }
    render () {
      
      if (this.state.redirect) {
        return (<Redirect to={this.props.config.equipe.professor.home}/>);
      }
  
      var lista = <div>
                    <div className="panel panel-azul-claro panel-cinza">
                      <div className="panel-body panel-body-lista-alunos">
                        {
                          !this.state.load ? "" : <AlunosListGruposturmas dadosUser = {this.props.all_alunos_equipe.alunos}/>
                        }
                      </div>
                    </div>
                  </div>;

        if(this.state.listaAlunos.length===0){
          return(<div></div>);
        }

        return (<div>
                 { this.state.load ? lista  : <FlashCarregando/>}
                    
                </div>);
    }
}

function mapStateToProps(state){

    return{
        equipe            : state.equipeReducer.nome_equipe,
        all_alunos_equipe : state.equipeReducer.all_aluno_equipe,
        config  : state.configReducer.menu
    }
}

export default connect(mapStateToProps,{GetGruposAlunos})(Equipe_Aluno_Lista);



// WEBPACK FOOTER //
// ./src/components/professor/timeline_equipe/equipe_aluno_lista.js